import { Fragment, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';

//Owl carousel
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

// import banner from "../../assets/resources/sucursales/sucursal_gdl.jpeg";
import logo_whatsapp from '../../assets/resources/sucursales/Logo_whatsApp.png';
import fb from '../../assets/resources/sucursales/Recurso.png';
import {
    buildGoogleMapsEmbedUrl,
    buildGoogleMapsSearchUrl
} from '../../helpers/admin/branch/googleMaps';

//MUI
import { Alert, Box, Button, Container, Grid, Typography, Skeleton, useMediaQuery } from '@mui/material';

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';

const options = {
    margin: 10,
    nav: false,
    dots: true,
    mouseDrag: false,
    responsive: {
        0: {
            items: 1,
        },
        400: {
            items: 1,
        },
        600: {
            items: 2,
        },
        700: {
            items: 2,
        },
        800: {
            items: 3,
        },
        1000: {
            items: 3,
        }
    }
};

const SucursalComponent = () => {
    const { sucursal } = useParams();
    const navigate = useNavigate();
    
    const matches = useMediaQuery('(max-width: 950px)');

    const { branches, fetched } = useSelector(state => state.shop);
    
    const currentBranch = branches.find(b => b.url === sucursal);

    // redireccionar si no se encuentra sucursal en lista
    useEffect(() => {
        if (fetched && !currentBranch) {
            // Si ya cargó pero no existe la sucursal, mandamos a 404 o lista
            navigate('/sucursales', { replace: true });
        }
    }, [fetched, currentBranch, navigate]);

    if (!fetched || !currentBranch)
        return (
            <Container spacing={2} sx={{ mt: matches ? 5 : 18, mb: 5 }}>
                <Skeleton variant="text" sx={{ fontSize: '2rem' }} />
                <Skeleton variant="rounded" height={120} />
            </Container>
        );

    const {
        title, url, email, phone, wspNumber, wspMessage, facebookUrl,
        googleMaps = {},
        address, img, businessHours
    } = currentBranch;

    const mapUrl = buildGoogleMapsSearchUrl(title, googleMaps);
    const embedUrl = buildGoogleMapsEmbedUrl(googleMaps, GOOGLE_MAPS_API_KEY);

    return (
        <>
            {/* Sucursal header */}
            <Container maxWidth="xl" sx={{ mt: matches ? 5 : 18 }}>
                <Typography variant='h4' align='center' sx={{ fontWeight: '600' }}>
                    {title}
                </Typography>
            </Container>
            {/* Fin Sucursal header */}

            {/* sucursal */}
            <Container maxWidth="xl" sx={{ mt: 5 }}>

                {/* Banner */}
                <img src={img} width="100%" alt={url} />

                <Typography variant='h5' align='center' sx={{ fontWeight: '600', mt: 2 }}>
                    SOMOS UNA CADENA DE TIENDAS ESPECIALIZADAS EN LA VENTA DE ALIMENTOS Y SUPLEMENTOS PARA PERSONAS CON ENFERMEDAD RENAL.
                </Typography>


                {/* Información de sucursal */}
                <OwlCarousel className='owl-theme' {...options} style={{ marginTop: '30px', textAlign: 'center' }}>
                    <div className='item'>
                        <i className="fa-solid fa-location-dot" style={{ fontSize: '2rem', marginBottom: '10px' }}></i>
                        <Typography variant="h5" sx={{ fontWeight: 'light', color: '#00a7e2' }} gutterBottom>Dirección</Typography>
                        <Typography variant="body1" gutterBottom>
                            {address}
                        </Typography>
                        {mapUrl && (
                            <a href={mapUrl} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                                <Button variant='contained'>Ver en mapa</Button>
                            </a>
                        )}
                    </div>
                    <div className='item'>
                        <i className="fa-regular fa-address-book" style={{ fontSize: '2rem', marginBottom: '10px' }}></i>
                        <Typography variant="h5" sx={{ fontWeight: 'light', color: '#00a7e2' }} gutterBottom>Contacto</Typography>
                        <Typography variant="body1">
                            Teléfono: {phone} <br /> WhatsApp: {wspNumber} <br /> {email}
                        </Typography>
                    </div>
                    <div className='item'>
                        <i className="fa-regular fa-clock" style={{ fontSize: '2rem', marginBottom: '10px' }}></i>
                        <Typography variant="h5" sx={{ fontWeight: 'light', color: '#00a7e2' }} gutterBottom>Horario</Typography>
                        {
                            businessHours.map(({ dayRange, hours }, i) => (
                                <Fragment key={i}>
                                    <Typography variant="body1">{dayRange}</Typography>
                                    <Typography variant="body1">{hours}</Typography>
                                </Fragment>
                            ))
                        }
                    </div>
                </OwlCarousel>
                {/* Fin Información de sucursal */}

                {/* enlace redes  */}
                <Grid container spacing={4} sx={{ textAlign: 'center', mt: 5 }}>
                    <Grid item xl={6} lg={6} md={6} sm={6} xs={12} sx={{ m: 'auto' }}>
                        <a href={wspMessage}
                            target="_blank" rel="noopener noreferrer">
                            <img src={logo_whatsapp} width="80%" className='social-img social-whats' alt={logo_whatsapp} />
                        </a>
                    </Grid>
                    {
                        facebookUrl &&
                            <Grid item xl={6} lg={6} md={6} sm={6} xs={12} sx={{ m: 'auto' }}>
                                <a href={facebookUrl}
                                    target="_blank" rel="noopener noreferrer">
                                    <img src={fb} alt={fb} width="60%" className='social-img' />
                                </a>
                            </Grid>
                    }
                    
                </Grid>
                {/* Fin enlace redes  */}

                <Box sx={{ textAlign: 'center', mt: 5 }}>
                    <Typography variant='body1' sx={{ color: '#00a7e2', fontWeight: 'bold' }}>
                        ¡Visita tu sucursal más cercana!
                    </Typography>
                    <Typography variant="h6" sx={{ color: '#00a7e2', fontWeight: 'bold' }}>
                        CONTAMOS CON MÁS DE 80 PRODUCTOS
                    </Typography>
                </Box>
            </Container>
            {/* Fin sucursal */}

            {/* Map */}
            <Container maxWidth="xl" sx={{ mt: 1 }} className="last-view">
                {embedUrl ? (
                    <iframe
                        src={embedUrl}
                        width="100%"
                        height="450"
                        title={`Mapa de ${title}`}
                        style={{ border: '0' }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    />
                ) : (
                    <Alert severity="info">
                        La ubicación de esta sucursal todavía no está disponible en Google Maps.
                    </Alert>
                )}
            </Container>
            {/* Fin Map */}
        </>
    );
};

export default SucursalComponent;
